module.exports = __webpack_public_path__ + "static/media/discount_code.20089762.svg";